import Router from 'vue-router';
import Vue from 'vue';
Vue.use(Router)
const vueRouter = new Router({
  mode: 'hash',
  base: process.env.VUE_APP_PATH,
  routes: [{
    path: '/',
    name: 'list',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/index')
  }, {
    path: '/create',
    name: 'create',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/create')
  }, {
    path: '/build/:id',
    name: 'build',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/build')
  },{
    path: '/edit/exportData',
    name: '导入数据',
    component: () =>
        import( /* webpackChunkName: "page" */ '@/page/exportData')
  },{
    path: '/view/:id',
    name: 'view',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/view')
  },{
    path: '/edit/weather',
    name: 'weather',
    component: () =>
        import( /* webpackChunkName: "page" */ '@/page/weather')
  },{
    path: '/login',
    name: 'login',
    component: () =>
        import( /* webpackChunkName: "page" */ '@/page/login')
  }]
})
vueRouter.beforeEach((to, from, next) => {
  // console.log('to',to)
  // console.log('from', from)
  if(to.path.includes('/view')){
    next();
  } else if(to.path.includes('/login')){
    // console.log('登录页')
    next();
  } else if(to.path.includes('/edit/exportData')){
    next();
  }  else if(to.path.includes('/edit/weather')){
    next();
  } else {
    let token = localStorage.getItem('token');
    if (token === 'export') {
      if(to.path.includes('/exportData')) {
        next();
      } else {
        next({ path: 'login' });
      }
    } else if (token === 'admin') {
      next();
    } else if (token === 'control') {
      if(to.path.includes('control')) {
        next();
      } else {
        next({ path: 'login' });
      }
    } else {
      // console.log('没有token')
      next({ path: 'login' });
    }
  }

  /*if (to.path === '/login') {
    next();
  } else if(to.path.includes('view')) {
    next();
  } else if(to.path.includes('operationAllocation')) {
    next();
  } else {
    // 从本地存储里获取token
    let token = localStorage.getItem('token');
    console.log("成功判断")
    // 判断token是否为空如果为空则跳转到登录页 如果有则放行
    if (token === null || token === '') {
      next({ path: '/login' });
    } else {
      next();
    }
  }*/
});
export default vueRouter;
